export default defineNuxtRouteMiddleware(async (to, from) => {
  // load logged in user
  const userStore = useUserStore()
  await userStore.fetchUser()
  return
})
